import type { SessionUser } from '@/types/api'

export const defaultAdminEmails = [
  'admin@miao-form.case4.app',
] as const

export const defaultSuperAdminEmails = [] as const

export function normalizePermissionEmail(email: string | null | undefined) {
  return email?.trim().toLocaleLowerCase() ?? ''
}

export function isAdminEmail(
  email: string | null | undefined,
  adminEmails: readonly string[] = defaultAdminEmails,
) {
  const normalizedEmail = normalizePermissionEmail(email)
  if (!normalizedEmail) return false
  return adminEmails.some((adminEmail) => normalizePermissionEmail(adminEmail) === normalizedEmail)
}

export function hasDirectFormAdminAccess(
  user:
    | (Pick<SessionUser, 'email' | 'role'> & Partial<Pick<SessionUser, 'productionRole'>>)
    | null
    | undefined,
  adminEmails: readonly string[] = defaultAdminEmails,
) {
  if (hasSuperAdminAccess(user)) return true
  if (user?.productionRole === 'admin') return true
  return user?.role === 'owner' || user?.role === 'admin' || isAdminEmail(user?.email, adminEmails)
}

export function hasFormAdminAccess(
  user:
    | (Pick<SessionUser, 'email' | 'role'> & Partial<Pick<SessionUser, 'productionRole'>>)
    | null
    | undefined,
  adminEmails: readonly string[] = defaultAdminEmails,
) {
  return hasDirectFormAdminAccess(user, adminEmails)
}

export function isSuperAdminEmail(
  email: string | null | undefined,
  superAdminEmails: readonly string[] = defaultSuperAdminEmails,
) {
  const normalizedEmail = normalizePermissionEmail(email)
  if (!normalizedEmail) return false
  return superAdminEmails.some(
    (superAdminEmail) => normalizePermissionEmail(superAdminEmail) === normalizedEmail,
  )
}

export function hasSuperAdminAccess(
  user:
    | (Pick<SessionUser, 'email'> & Partial<Pick<SessionUser, 'role' | 'productionRole'>>)
    | null
    | undefined,
) {
  if (user?.productionRole === 'super_admin') return true
  if (user?.role === 'owner') return true
  return false
}
